if (!customElements.get("recently-viewed")) {
  customElements.define(
    "recently-viewed",
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.isLoaded = false;
      }

      connectedCallback() {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(this.loadProducts.bind(this), { timeout: 1500 });
        } else {
          this.loadProducts();
        }
      }

      getSearchQueryString() {
        const items = new Set(
          JSON.parse(
            localStorage.getItem("theme:recently-viewed") || "[]"
          )
        );
        if (this.hasAttribute("exclude-id")) {
          items.delete(parseInt(this.getAttribute("exclude-id")));
        }
        return Array.from(items.values(), (item) => `id:${item}`).join(" OR ");
      }

      async loadProducts() {
        if (this.isLoaded) return;
        this.isLoaded = true;

        const section = this.closest(".shopify-section");
        const url = `${
          window.routes.root_url
        }search?type=product&q=${this.getSearchQueryString()}&section_id=${extractSectionId(
          section
        )}`;
        const response = await fetch(url, { priority: "low" });
        const tempDiv = new DOMParser().parseFromString(
          await response.text(),
          "text/html"
        );
        const recentlyViewedElement = tempDiv.querySelector(
          "recently-viewed"
        );

        if (recentlyViewedElement.childElementCount > 0) {
          this.replaceChildren(
            ...document.importNode(recentlyViewedElement, true)
              .childNodes
          );
        } else {
          section.remove();
        }
      }
    }
  );
}
function extractSectionId(element) {
  element = element.classList.contains("shopify-section")
    ? element
    : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}
